import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'priceFormat' })
export class PriceFormatPipe implements PipeTransform {
  transform(priceCents: number): string {
    return isNaN(priceCents) || priceCents <= 0
      ? '0'
      : (priceCents / 100).toFixed(2).replace('.', ',');
  }
}
